<template>
  <v-dialog v-model="show" width="700">
    <v-card :loading="loading">
      <v-card-title class="primary--text pr-4">
        {{ isExistingUser ? 'Edit User Details' : 'Add User' }}
        <v-spacer />
        <v-btn icon color="grey" text @click="show = false" :disabled="loading"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-form ref="form" @submit.prevent>
          
           
              <v-select v-model="selectedUserRoleId" :items="userRoles" label="User Role" item-text="name"
   item-value="id"></v-select>
         
        <multiselect  
        v-if="selectedUserRoleId==5"
                v-model="selectedDrivers" 
                :placeholder="`Search for drivers`" 
                label="email" 
                track-by="id" 
                :options="drivers" 
                :multiple="true" 
                :taggable="true"
                :hide-selected="true"
                :class="generateChipStyle('orange')"
                style="background:none !important; margin-bottom:4%;"
                
            >
            </multiselect>
        <multiselect  
                v-if="selectedUserRoleId==5"
                v-model="selectedTrucks" 
                :placeholder="`Search for truck`" 
                label="truckIdentifier" 
                track-by="truckIdentifier" 
                :options="trucks" 
                :multiple="true" 
                :taggable="true"
                :hide-selected="true"
                :class="generateChipStyle('orange')"
                style="background:none !important; margin-bottom:4%;"
               
            >
            </multiselect>
          <v-text-field :rules="rules.email" color="green" outlined dense label="Email Address" append-icon="mdi-account" v-model="data.email"/>
          <v-text-field  color="green" outlined dense label="Name" append-icon="mdi-account" v-model="data.userFullName"/>
          
          <v-text-field   color="green" outlined dense label="Company" append-icon="mdi-account" v-model="data.company"/>
          <v-text-field   color="green" outlined dense label="Phone" append-icon="mdi-account" v-model="data.phone"/>
          <v-text-field   color="green" outlined dense label="Address" append-icon="mdi-account" v-model="data.address"/>
          <v-checkbox color="primary" v-model="data.otpEnabled" :value="data.otpEnabled" label="OTP Enabled"></v-checkbox>

          <div v-if="isExistingUser" class="pb-3 green--text"><v-icon color="green" class="mr-2">info</v-icon>*While updating User Details changing password is must, tick the box below to change.</div>
          <v-checkbox v-if="isExistingUser" color="primary" v-model="changePassword" label="Change Password" class="pa-0 ma-0"></v-checkbox>
          <template v-if="changePassword || !isExistingUser">
           
            <v-text-field :rules="rules.password" type="password" color="green" outlined dense :label="isExistingUser ? 'Current Password' : 'Password'" append-icon="mdi-lock" v-model="data.password"/>
            <v-text-field :rules="rules.newPassword" type="password" v-if="isExistingUser" color="green" outlined dense label="New Password" v-model="data.newPassword"/>
            <v-text-field :rules="rules.confirmPassword" type="password" color="green" outlined dense label="Confirm Password" v-model="data.confirmPassword"/>
            
          </template>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-dialog v-if="isExistingUser && allowDelete" v-model="showDeleteConfirm" max-width="290">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text :disabled="loading" @delete="showDeleteConfirm">Delete</v-btn>
          </template>
          <v-card>
            <v-card-title class="headline primary--text">
              <v-icon color="primary" class="mr-2">error</v-icon>
              Confirmation
            </v-card-title>
            <v-card-text>Are you sure do you want to delete this user?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" text @click="showDeleteConfirm = false">No</v-btn>
              <v-btn color="red" text @click="deleteThisUser">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer />
        <span v-if="errorMessage !== ''" class="ml-4 orange--text d-flex align-center">
          <v-icon color="orange" class="mr-2">error</v-icon>
          {{errorMessage}}
        </span>
        <v-spacer />
        <v-btn color="red" text @click="show = false" :disabled="loading">Close</v-btn>
        <v-btn color="green" text @click="save" :disabled="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Trucks from '../views/Trucks'
import Drivers from '../views/Drivers'
import { mapState, mapActions, mapGetters } from 'vuex' 
import Multiselect from 'vue-multiselect'
import MultiSelectChipStyle from '../mixins/multiselect_chip_style'
export default { 
    mixins:[MultiSelectChipStyle],
  data() {
    return {
      trucks:[],
      drivers:[],
      selectedDrivers:[],
      selectedTrucks:[], 
      userRoles: [
            {id: 1, name: "Admin"},
            {id: 3, name: "Client"}, 
            {id: 5, name: "Freight Forwarder"}
        ],
      errorMessage: '',
      data: {
        UserRoleId:1 //admin
      },
      selectedUserRoleId: "",
      changePassword: false,
      enableValidation: false,
      showDeleteConfirm: false,
      rules: {
        email: [
          v => !!v || 'Email is required',
        ],
        password: [
          v => !!v || 'Password is required',
        ],
        newPassword: [
          v => !!v || 'New password is required'
        ],
        confirmPassword: [
          v => !!v || 'Confirm password is required',
          v => (v && ((!this.isExistingUser && v == this.data.password) || (this.isExistingUser && v == this.data.newPassword))) || (this.isExistingUser? 'New Password' : 'Password') + ' and Confirm Password should match'
        ]
      }
    }
  }, 
  mounted(){   
    this.reloadAvailableTrucks();
          this.drivers=this.entities['driver'];
  },
  components:{ Multiselect,Trucks,Drivers},
  computed: { 
        ...mapState('entities',['loading','entities']),
    show: {
      get() {
        return this.isShown
      },
      set(value) {
        this.$emit('changed', value)
      }
    },
    isExistingUser() {
      return this.user != undefined && this.user.id
    },
    ...mapState('users',['loading']),
    ...mapGetters('users',['allowDelete'])
  },
  props: {
    isShown: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    }
  },
  methods: {
    ...mapActions('users',['getUsers','saveUser','deleteUser','saveFFUser']),
        reloadAvailableTrucks() {
            //load the trucks available to be assigned for this driver
            //var url = `/trucks/availableTrucks`
            var url = `truck/list`
            axios({
                method:"GET",
                url:`${process.env.VUE_APP_baseURL}${url}`,
            }).then(response=>{
                console.log(response)
                this.trucks = response.data.data 
                console.log(this.trucks)
                this.loading = false
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`)
            })
        },reloadFFInfo(userid) {   
            var url = `user/getFFInfo?UserId=` + userid
            axios({
                method:"GET",
                url:`${process.env.VUE_APP_baseURL}${url}`,
            }).then(response=>{  
                this.selectedDrivers =response.data.data.driverIds;
                this.selectedTrucks=response.data.data.truckIds;
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`)
            })

        },
    notEmpty(value) {
      if (value != undefined)
        return value.password !== null && value.password != '' && value.password !== undefined
      return false
    },
    save() {
      //this.data.UserRoleId=3;   
      if(this.changePassword){
        this.data.password = this.data.confirmPassword;
      }
      this.data.userRoleId = this.selectedUserRoleId;
      if (this.$refs.form.validate()) {
        this.errorMessage = ''
        this.saveUser(this.data).then(message => {  
          if(this.data.userRoleId ==5){
              //update freight forwarder 
            let req ={
              Email:this.data.email,
              driverEmails:this.selectedDrivers.map(a => a.email),
              truckIdentificers:this.selectedTrucks.map(a=>a.truckIdentifier)
            }  
            this.saveFFUser(req).then(message => {                   
                  this.show = false;  
                  this.getUsers(); 
                }).catch(message => {
                  this.errorMessage = "Validation error Occurred!"
                })
                    
          } else{          
                  this.show = false; 
                  this.getUsers(); 
          }
              
        }).catch(message => {
          this.errorMessage = message
          this.errorMessage = "Validation error Occurred!"
        })
      }
      this.enableValidation = true
    },
    deleteThisUser() {
      this.showDeleteConfirm = false
      this.deleteUser(this.data).then(message => {
        this.show = false
      }).catch(message => {
        this.errorMessage = message
      })
    }
  },
  model: {
    prop: 'isShown',
    event: 'changed'
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.data = Object.assign({}, this.user)  
        this.selectedUserRoleId=this.data.userRoleId;
        this.reloadFFInfo(this.user.id);
        
        if (this.$refs.form != undefined)
          this.$refs.form.resetValidation()
        this.errorMessage = ''
        this.enableValidation = false
      }
    },
    data: {
      deep: true,
      handler() {
        if (this.enableValidation)
          this.$refs.form.validate()
      }
    }
  }
}
</script>